import logo from './logo.svg';
import './App.css';
import Homeindex from './app/home/homeindex';
import Header from './shared/header';
import { Routes, Route, BrowserRouter, Link, useLocation } from "react-router-dom";
import Aboutusindex from './app/aboutus/aboutusindex';
import Homemadepage from './app/home/section/homeeservices/services/pages/homemadepage';
import Restaurantpage from './app/home/section/homeeservices/services/pages/restaurantpage';
import Plantnnurserypage from './app/home/section/homeeservices/services/pages/plantnnurserypage';
import Pickupndroppage from './app/home/section/homeeservices/services/pages/pickupndroppage';
import Homeservicepage from './app/home/section/homeeservices/services/pages/homeservicepage';
import Footer from './shared/footer';
import Ourteam from './app/ourteam/ourteam';
import Career from './app/career/career';
import Consultant from './app/consultant/consultant';
import Foods from './app/consultant/foods/foods';
import Blog from './app/blog/blog';
import Blogpage from './app/blog/blogpage/blogpage';
import Contactus from './app/contactus/contactus';
import ReactJS from './app/career/careerform/ReactJS';
import Reactnative from './app/career/careerform/reactnative';
import Java from './app/career/careerform/java';
import Firebase from './app/career/careerform/firebase';
import Nodejs from './app/career/careerform/nodejs';
import Graphicdesigner from './app/career/careerform/graphicdesigner';
import UInUXdesigner from './app/career/careerform/uinuxdesigner';
import Videoeditor from './app/career/careerform/videoeditor';
import RefundCancellation from './app/Refund & Cancellation/RefundCancellation';
import ChefAgreement from './app/Chef Agreement/ChefAgreement';
import CaterersSaviour from './app/Caterers Saviour/CaterersSaviour'
import PrivacyPolicy from './app/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './app/Terms&Conditions/termsCondtions.js';
import OrderPage from './CocopeatDashboard/OrderFlow/OrderPage.jsx';
import CoocpeatHome, { ApiKey, baseurl } from './CocopeatDashboard/CoocpeatHome.jsx';
import CartItems from './CocopeatDashboard/Cart/CartItems.jsx';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Cookies from "js-cookie";
// import Indexpage from './CocopeatDashboard/indexpage';
import getAddressFromCoords from './utils/getAddressFromCoords';
import AddressComp from './CocopeatDashboard/Cart/AddressComp.jsx';









function App() {
  const location = useLocation();
  const hideHeaderFooter = location.pathname === '/Order' || location.pathname === '/Cart' || location.pathname === '/OrderPage' || location.pathname === '/AddressSection';


  const [locationData, setLocationData] = useState(null);

  // ✅ Create unknown user in backend
  const saveUnknownUserWithLocation = async (location) => {
    try {
      const { data } = await axios.post(`${baseurl}users/Unknownuser`, { location });

      if (data?.userId) {
        Cookies.set("userId", data.userId, { expires: 365 });
        console.log("✅ User created:", data.userId);
        return data.userId;
      } else {
        console.warn("⚠️ Backend did not return a userId");
        return null;
      }
    } catch (err) {
      console.error("❌ Backend location error:", err);
      return null;
    }
  };



  // ✅ Get browser location
  const getUserLocation = async () => {
    if (!navigator.geolocation) {
      alert("Geolocation not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        console.log("📍 Coordinates:", latitude, longitude);

        const address = await getAddressFromCoords(latitude, longitude); // define this util or mock
        const location = { latitude, longitude, address };

        setLocationData(location);
        localStorage.setItem("userLocation", JSON.stringify(location));

        const userId = Cookies.get("userId");
        if (!userId) {
          await saveUnknownUserWithLocation(location);
        }
      },
      (error) => {
        if (error.code === error.PERMISSION_DENIED) {
          alert("Please enable location access for delivery.");
        } else {
          console.error("⚠️ Location error:", error.message);
        }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  };

  // ✅ Ask permission and get location
  const requestUserLocation = async () => {
    try {
      const permissionStatus = await navigator.permissions.query({ name: "geolocation" });
      console.log("🔐 Permission state:", permissionStatus.state);

      if (permissionStatus.state === "granted" || permissionStatus.state === "prompt") {
        getUserLocation();
      } else if (permissionStatus.state === "denied") {
        alert("Location access is blocked. Enable it in your browser settings.");
      }
    } catch (err) {
      console.error("Permission check failed:", err);
      getUserLocation(); // fallback
    }
  };

  useEffect(() => {
    // console.log("🌐 App mounted");
    const storedLocation = localStorage.getItem("userLocation");
    const existingUserId = Cookies.get("userId");

    if (storedLocation) {
      setLocationData(JSON.parse(storedLocation));
      // console.log("📦 Using saved location:", JSON.parse(storedLocation));
    } else {
      requestUserLocation();
    }
    // Cookies.remove("userId"); // For testing: always create new user
    // console.log("👤 Existing userId:", existingUserId || "none");
  }, []);

  useEffect(() => {
    if (!Cookies.get("userId") && locationData) {
      saveUnknownUserWithLocation(locationData);
    }
    console.log("📍 Location data updated:", locationData);
  }, []);


  return (
    <div className="App">

      {!hideHeaderFooter && <Header />}
      <Routes>
        {/* Landing Page Routes */}
        <Route path='CaterersSaviour' element={<CaterersSaviour />} />
        <Route path='ChefAgreement' element={<ChefAgreement />} />
        <Route path='RefundCancellation' element={<RefundCancellation />} />
        <Route path='Privacypolicy' element={<PrivacyPolicy />} />
        <Route path='TermsConditions' element={<TermsConditions />} />
        <Route path='reactjs' element={<ReactJS />} />
        <Route path='reactnative' element={<Reactnative />} />
        <Route path='java' element={<Java />} />
        <Route path='firebase' element={<Firebase />} />
        <Route path='nodejs' element={<Nodejs />} />
        <Route path='graphicdesigner' element={<Graphicdesigner />} />
        <Route path='ui&uxdesigner' element={<UInUXdesigner />} />
        <Route path='videoeditor' element={<Videoeditor />} />
        <Route path='homeservices' element={<Homeservicepage />} />
        <Route path='Pickup&drop' element={<Pickupndroppage />} />
        <Route path='plant&nursery' element={<Plantnnurserypage />} />
        <Route path='restaurantfood' element={<Restaurantpage />} />
        <Route path='homemade' element={<Homemadepage />} />
        <Route path='contactus' element={<Contactus />} />
        <Route path='blogpage' element={<Blogpage />} />
        <Route path='blog' element={<Blog />} />
        <Route path='consultant' element={<Consultant />} />
        <Route path='career' element={<Career />} />
        <Route path='ourteam' element={<Ourteam />} />
        <Route path='aboutus' element={<Aboutusindex />} />
        <Route path='/' element={<Homeindex />} />
        {/* Order Routes */}
        <Route path='Order' element={<CoocpeatHome />} />
        <Route path='OrderPage' element={<OrderPage />} />
        <Route path='Cart' element={<CartItems locationData={locationData} />} />
        <Route path='AddressSection' element={<AddressComp />} />
      </Routes>
      {!hideHeaderFooter && <Footer />}


    </div>
  );
}

export default App;
